// extracted by mini-css-extract-plugin
module.exports = {"item":"Item_item__3RTsL","avatar":"Item_avatar__22-af","man":"Item_man__1zWPj","position":"Item_position__SEVZV"};